'use strict';
define([], function() {
    function Controller($scope, $mdDialog, projectId, competitorId, ProjectsService) {
        $scope.projectId = projectId;
        $scope.loading = false;
        $scope.cancelDialog = cancelDialog;
        $scope.answerDialog = answerDialog;
        
        function answerDialog() {
            if ($scope.loading) {
                return;
            }
            $scope.loading = true;
            ProjectsService.deleteCompetitor(projectId, competitorId)
                .then(function() {
                    hideDialog();
                })
                .catch(function(err) {
                    $scope.loading = false;
                    console.log(err);
                });
        }
        function hideDialog() {
            $mdDialog.hide();
        }
        function cancelDialog() {
            $mdDialog.cancel();
        }
    }
    Controller.$inject=['$scope', '$mdDialog', 'projectId', 'competitorId', 'ProjectsService'];
    return Controller;
});
